import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from 'react-router-dom';
import {pushRequest} from '@/lib/staffPwa';
import {staffDestination} from '@/lib/staffDestination';

export function StaffNotification() {
    const {id} = useParams(), navigate = useNavigate();
    const [error, setError] = useState('');
    useEffect(() => {
        let active = true;
        setError('');
        pushRequest('notifications/' + encodeURIComponent(id)).then(result => {
            if (active) navigate(staffDestination(result.url, '/staff/appointments'), {replace:true});
        }).catch(() => {if (active) setError('This notification has expired or belongs to a different staff account.');});
        return () => {active = false;};
    }, [id, navigate]);
    return <section className="glass rounded-2xl p-5 space-y-4">
        <h1 className="font-serif text-2xl">Notification details</h1>
        {error ? <><p role="alert">{error}</p><Link to="/staff/appointments" className="text-gold">View appointments</Link><br/><Link to="/staff/forms/review" className="text-gold">View completed forms</Link></> : <p role="status">Opening the appointment or form…</p>}
    </section>;
}
